import { mockResponse } from '@/utils/format'

const quotaData = [
  { month: '2025-01', predicted: 600000, actual: 580000, diff: 20000 },
  { month: '2025-02', predicted: 610000, actual: 620000, diff: -10000 },
  { month: '2025-03', predicted: 620000, actual: 640000, diff: -20000 },
  { month: '2025-04', predicted: 630000, actual: 660000, diff: -30000 },
  { month: '2025-05', predicted: 640000, actual: 650000, diff: -10000 },
  { month: '2025-06', predicted: 650000, actual: null, diff: null },
  { month: '2025-07', predicted: 660000, actual: null, diff: null },
  { month: '2025-08', predicted: 670000, actual: null, diff: null },
  { month: '2025-09', predicted: 680000, actual: null, diff: null },
  { month: '2025-10', predicted: 690000, actual: null, diff: null },
  { month: '2025-11', predicted: 700000, actual: null, diff: null },
  { month: '2025-12', predicted: 710000, actual: null, diff: null }
]

export function getQuotaWarningData() {
  return mockResponse({
    periodType: 'month',
    quotaWarning: quotaData,
    forecastStartIndex: 5
  })
}

const marketTypes = ['全国碳市场', '北京试点', '上海试点', 'CCER']

const priceTrendDates = [
  '2025-06-01', '2025-06-05', '2025-06-10', '2025-06-15',
  '2025-06-20', '2025-06-25', '2025-06-30', '2025-07-05'
]

const marketList = [
  { date: '2025-07-07', marketName: '全国碳市场', open: 77.2, close: 78.5, high: 79.1, low: 76.8, volume: 12.5, changeRate: 1.2 },
  { date: '2025-07-06', marketName: '全国碳市场', open: 76.5, close: 77.6, high: 78.0, low: 76.2, volume: 11.8, changeRate: 0.8 },
  { date: '2025-07-05', marketName: '北京试点', open: 95.0, close: 96.3, high: 97.1, low: 94.5, volume: 2.1, changeRate: -0.5 },
  { date: '2025-07-04', marketName: '上海试点', open: 68.0, close: 69.2, high: 70.0, low: 67.5, volume: 1.8, changeRate: 1.5 },
  { date: '2025-07-03', marketName: 'CCER', open: 52.0, close: 53.5, high: 54.0, low: 51.8, volume: 3.2, changeRate: 2.1 },
  { date: '2025-07-02', marketName: '全国碳市场', open: 75.8, close: 76.9, high: 77.5, low: 75.2, volume: 10.6, changeRate: -0.3 },
  { date: '2025-07-01', marketName: '全国碳市场', open: 76.0, close: 77.1, high: 77.8, low: 75.5, volume: 9.8, changeRate: 0.6 },
  { date: '2025-06-30', marketName: '北京试点', open: 94.2, close: 95.8, high: 96.5, low: 93.8, volume: 2.0, changeRate: 0.4 }
]

export function getMarketData() {
  return mockResponse({
    lastUpdated: '2025-07-07 14:30:00',
    marketTypes,
    summary: {
      latestPrice: { today: 78.5, annual: 76.2, unit: '元/tCO2' },
      dailyChange: { today: 1.2, annual: 3.8, unit: '%' },
      volume: { today: 12.5, annual: 2850, unit: '万吨' },
      turnover: { today: 980, annual: 218000, unit: '万元' }
    },
    priceTrend: {
      dates: priceTrendDates,
      closePrice: [72.5, 73.8, 74.2, 75.6, 76.1, 77.0, 77.6, 78.5],
      volume: [8.2, 9.5, 10.1, 9.8, 11.2, 10.6, 11.8, 12.5]
    },
    marketShare: [
      { name: '全国碳市场', value: 65 },
      { name: '北京试点', value: 15 },
      { name: '上海试点', value: 12 },
      { name: 'CCER', value: 8 }
    ],
    marketList
  })
}

const MARKET_PRICE = 78.5

const assetTypes = ['配额', 'CCER', '试点配额']
const assetSources = ['政府分配', '市场购买', '减排项目']
const assetStatuses = [
  { value: 'available', label: '可用' },
  { value: 'frozen', label: '冻结' },
  { value: 'fulfilled', label: '已履约' }
]

const registerAssets = [
  {
    id: 1,
    assetNo: 'CA-2025-001',
    assetType: '配额',
    quantity: 200000,
    source: '政府分配',
    acquireDate: '2025-01-15',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: '2025年度初始分配配额'
  },
  {
    id: 2,
    assetNo: 'CA-2025-002',
    assetType: '配额',
    quantity: 150000,
    source: '市场购买',
    acquireDate: '2025-03-20',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: '全国碳市场购入，用于补充履约缺口'
  },
  {
    id: 3,
    assetNo: 'CA-2025-003',
    assetType: '配额',
    quantity: 120000,
    source: '政府分配',
    acquireDate: '2025-02-10',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'frozen',
    statusLabel: '冻结',
    remark: '预留给重点减排项目'
  },
  {
    id: 4,
    assetNo: 'CA-2025-004',
    assetType: '配额',
    quantity: 80000,
    source: '市场购买',
    acquireDate: '2025-04-08',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'fulfilled',
    statusLabel: '已履约',
    remark: '2024年度履约清缴已使用'
  },
  {
    id: 5,
    assetNo: 'CA-2025-005',
    assetType: 'CCER',
    quantity: 80000,
    source: '减排项目',
    acquireDate: '2025-01-20',
    expireDate: '2028-12-31',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: '光伏发电CCER项目签发'
  },
  {
    id: 6,
    assetNo: 'CA-2025-006',
    assetType: 'CCER',
    quantity: 50000,
    source: '市场购买',
    acquireDate: '2025-05-12',
    expireDate: '2027-06-30',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: 'CCER市场购入，用于抵消'
  },
  {
    id: 7,
    assetNo: 'CA-2025-007',
    assetType: 'CCER',
    quantity: 20000,
    source: '减排项目',
    acquireDate: '2025-03-05',
    expireDate: '2028-03-05',
    year: '2025',
    status: 'frozen',
    statusLabel: '冻结',
    remark: '林业碳汇项目，待核证'
  },
  {
    id: 8,
    assetNo: 'CA-2025-008',
    assetType: '试点配额',
    quantity: 100000,
    source: '政府分配',
    acquireDate: '2025-01-10',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: '北京试点碳市场分配'
  },
  {
    id: 9,
    assetNo: 'CA-2025-009',
    assetType: '试点配额',
    quantity: 50000,
    source: '市场购买',
    acquireDate: '2025-06-01',
    expireDate: '2025-12-31',
    year: '2025',
    status: 'available',
    statusLabel: '可用',
    remark: '上海试点碳市场购入'
  }
]

function buildRegisterSummary(assets) {
  const totalQuantity = assets.reduce((sum, item) => sum + item.quantity, 0)
  const available = assets
    .filter(item => item.status === 'available')
    .reduce((sum, item) => sum + item.quantity, 0)
  const frozen = assets
    .filter(item => item.status === 'frozen')
    .reduce((sum, item) => sum + item.quantity, 0)
  const totalValue = totalQuantity * MARKET_PRICE / 10000
  return {
    totalQuantity: { today: totalQuantity, annual: totalQuantity, unit: 'tCO2' },
    available: { today: available, annual: available, unit: 'tCO2' },
    frozen: { today: frozen, annual: frozen, unit: 'tCO2' },
    totalValue: { today: totalValue, annual: totalValue, unit: '万元' }
  }
}

export function getRegisterData(params = {}) {
  let assets = [...registerAssets]
  if (params.assetType) {
    assets = assets.filter(item => item.assetType === params.assetType)
  }
  if (params.year) {
    assets = assets.filter(item => item.year === params.year)
  }
  if (params.status) {
    assets = assets.filter(item => item.status === params.status)
  }
  return mockResponse({
    assetTypes,
    assetSources,
    assetStatuses,
    years: ['2025', '2024'],
    summary: buildRegisterSummary(assets),
    assets
  })
}

const monthlyHoldings = [
  620000, 635000, 648000, 662000, 675000, 690000,
  705000, 718000, 730000, 742000, 795000, 850000
]

export function getStatisticsData(params = {}) {
  const year = params.year || '2025'
  const quotaTotal = 550000
  const ccerTotal = 150000
  const pilotTotal = 150000
  const totalQuantity = quotaTotal + ccerTotal + pilotTotal
  const totalValue = totalQuantity * MARKET_PRICE / 10000

  let typeShare = [
    { name: '配额', value: quotaTotal },
    { name: 'CCER', value: ccerTotal },
    { name: '试点配额', value: pilotTotal }
  ]
  if (params.assetType === '配额') {
    typeShare = [{ name: '配额', value: quotaTotal }]
  } else if (params.assetType === 'CCER') {
    typeShare = [{ name: 'CCER', value: ccerTotal }]
  }

  const categorySummary = [
    {
      assetType: '配额',
      quantity: quotaTotal,
      ratio: quotaTotal / totalQuantity * 100,
      available: 430000,
      value: quotaTotal * MARKET_PRICE / 10000
    },
    {
      assetType: 'CCER',
      quantity: ccerTotal,
      ratio: ccerTotal / totalQuantity * 100,
      available: 130000,
      value: ccerTotal * MARKET_PRICE / 10000
    },
    {
      assetType: '试点配额',
      quantity: pilotTotal,
      ratio: pilotTotal / totalQuantity * 100,
      available: 150000,
      value: pilotTotal * MARKET_PRICE / 10000
    }
  ].filter(item => !params.assetType || item.assetType === params.assetType)

  return mockResponse({
    year,
    assetTypes: ['全部', '配额', 'CCER', '试点配额'],
    summary: {
      quotaTotal: { today: quotaTotal, annual: quotaTotal, unit: 'tCO2' },
      ccerTotal: { today: ccerTotal, annual: ccerTotal, unit: 'tCO2' },
      totalValue: { today: totalValue, annual: totalValue, unit: '万元' },
      yoyChange: { today: 8.6, annual: 8.6, unit: '%' }
    },
    typeShare,
    monthlyTrend: {
      months: Array.from({ length: 12 }, (_, i) => `${year}-${String(i + 1).padStart(2, '0')}`),
      holdings: monthlyHoldings
    },
    categorySummary
  })
}

const industries = ['电力', '钢铁', '水泥', '化工', '造纸']

function buildCalculationMonthly(params = {}) {
  const outputFactor = (params.output || 1000000) / 1000000
  const baselineFactor = (params.baseline || 0.85) / 0.85
  const reductionFactor = 1 - (params.reductionRate || 2) / 100

  return quotaData.map((item, index) => {
    const factor = outputFactor * baselineFactor * reductionFactor
    const predicted = Math.round(item.predicted * factor)
    const actual = item.actual != null ? Math.round(item.actual * factor * 1.02) : null
    const diff = actual != null ? predicted - actual : null
    return {
      month: item.month,
      predicted,
      actual,
      diff,
      isForecast: index >= 5
    }
  })
}

export function getCalculationData(params = {}) {
  const monthlyDetails = buildCalculationMonthly(params)
  const predictedTotal = monthlyDetails.reduce((sum, item) => sum + item.predicted, 0)
  const actualTotal = monthlyDetails
    .filter(item => item.actual != null)
    .reduce((sum, item) => sum + item.actual, 0)
  const forecastActualTotal = Math.round(actualTotal / 5 * 12)
  const gap = predictedTotal - forecastActualTotal
  const complianceCost = gap < 0 ? Math.abs(gap) * MARKET_PRICE / 10000 : 0
  const forecastStartIndex = 5

  return mockResponse({
    industries,
    defaultParams: {
      year: params.year || '2025',
      industry: params.industry || '电力',
      output: params.output || 1000000,
      baseline: params.baseline || 0.85,
      reductionRate: params.reductionRate || 2
    },
    marketPrice: MARKET_PRICE,
    summary: {
      predictedQuota: { today: predictedTotal, annual: predictedTotal, unit: 'tCO2' },
      predictedEmission: { today: forecastActualTotal, annual: forecastActualTotal, unit: 'tCO2' },
      gap: { today: gap, annual: gap, unit: 'tCO2' },
      complianceCost: { today: complianceCost, annual: complianceCost, unit: '万元' }
    },
    monthlyDetails,
    forecastStartIndex
  })
}
